export const mergeArrayObjects = objects => {
  const finalObject = {}

  objects.forEach(item => {
    Object.keys(item).forEach(key => (finalObject[key] = item[key]))
  })

  return finalObject
}
